import React, { Dispatch, SetStateAction, useState, useEffect,useContext } from "react";
import { Row, Col, Modal, ModalHeader, ModalBody } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { useQuery } from "@apollo/client";
import {
  GET_API_PROVIDER,
  GET_EMAILS,
  GET_PHONE_NUMBERS,
  GET_USER_ORGADMIN_ROLE,
} from "./query";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  AddOpeningHours,
  CreateOrganisation,
  IAddOpeningHoursProps,
  ICreateOrgProps,
} from "src/common/orgUtility";
import {
  AddUserToRole,
  CreateUser,
  IAddUserToRoleProps,
  ICreateUserProps,
} from "src/common/userUtility";
import {
  AddUserToInbox,
  CreateApiAccount,
  CreateAutomation,
  CreateFolder,
  CreateInbox,
  GET_INBOX_PLANS,
  IAddUserToInboxProps,
  ICreateApiProps,
  ICreateAutomationReponse,
  ICreateFolderProps,
  ICreateInboxProps,
} from "src/common/inboxUtility";
import { ThemeContext } from "src/helpers/themeContext";
interface IProps {
  modal: boolean;
  setModal: Dispatch<SetStateAction<boolean>>;
  onRefetch: any;
}

const extractBackendError = (err: any): string => {
  return (
    err?.graphQLErrors?.[0]?.message ||
    err?.networkError?.result?.errors?.[0]?.message ||
    err?.message ||
    ""
  );
};

const isDuplicateKeyError = (err: any): boolean => {
  const msg = extractBackendError(err).toLowerCase();
  return msg.includes("uniqueness violation") || msg.includes("duplicate key");
};

const AddOrganisation = (props: IProps) => {
  const [dynamic_description, setdynamic_description] =
    useState<React.ReactNode>("");
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [failure_dlg, setfailure_dlg] = useState(false);
  const [plans, setPlans] = useState<any>([])
  const [houseAccountOptions, setHouseAccountOptions] = useState([{value: 0, label: "False"}, {value: 1, label: "True"}])
  const [houseAccount, setHouseAccount] = useState(houseAccountOptions[0].value)

  const { data: apidata } = useQuery(GET_API_PROVIDER, {
    fetchPolicy: "no-cache",
  });
  const { data: orgAdminRoleDate } = useQuery(GET_USER_ORGADMIN_ROLE, {
    fetchPolicy: "no-cache",
  });
  const {data: planData} = useQuery(GET_INBOX_PLANS)
  const { data: emailData, error: emailError } = useQuery(GET_EMAILS, {
    fetchPolicy: "network-only",
  });
  const { data: phoneData, error: phoneError } = useQuery(GET_PHONE_NUMBERS, {
    fetchPolicy: "network-only",
  });
  const [existingEmails, setExistingEmails] = useState<string[]>([]);
  const [existingPhoneNumbers, setExistingPhoneNumbers] = useState<string[]>(
    []
  );

  useEffect(() => {
    if (emailError) console.error("GET_EMAILS failed:", emailError);
    if (!emailData) return;
    const arr = (emailData.msgbox_User ?? [])
      .map((u: any) => u.EMail)
      .filter(Boolean)
      .map((e: string) => e.toLowerCase());
    setExistingEmails(arr);
  }, [emailData, emailError]);

  useEffect(() => {
    if (phoneError) console.error("GET_PHONE_NUMBERS failed:", phoneError);
    if (!phoneData) return;
    const arr = (phoneData.msgbox_APIAccount ?? [])
      .map((a: any) => a.PhoneNumber)
      .filter(Boolean);
    setExistingPhoneNumbers(arr);
  }, [phoneData, phoneError]);
  const Theme = useContext(ThemeContext);
  const handleShow = () => {
    props.setModal(false);
  };
  const toggle = () => {
    props.setModal(!props.modal);

  };

  useEffect(()=>{
    if(planData){
      let newArray = [];
      for (let index = 0; index < planData.msgbox_Plan.length; index++) {
        const element = planData.msgbox_Plan[index];
        newArray.push({
          value: element.PlanId,
          label: element.Name,
        });
      }
      setPlans(newArray)
    }
  },[planData])


  const handleValidOrganisationSubmit = async (values: any) => {
    const completed: string[] = [];
    let orgCreated = false;
    const companyName = values["companyname"];
    const email = values["email"];
    const phoneNumber = values["phonenumber"];

    const fail = (step: string, err: any, hint: string) => {
      const details = extractBackendError(err);
      setdynamic_description(
        <div style={{ textAlign: "left" }}>
          <p className="mb-2">
            <strong>Failed step:</strong> {step}
          </p>
          <p className="mb-2">
            <strong>Reason:</strong> {hint}
          </p>
          {completed.length > 0 && (
            <p className="mb-2">
              <strong>Already completed:</strong> {completed.join(", ")}.
            </p>
          )}
          <p className="mb-2">
            <strong>Next step:</strong>{" "}
            {orgCreated
              ? `Do not retry this form — the organisation "${companyName}" has already been created and resubmitting will create a duplicate. Please contact support with the technical details below so they can finish the setup or clean it up.`
              : "Nothing was created. You can safely correct the details above and retry. If the problem persists, contact support."}
          </p>
          {details && (
            <p className="mb-0" style={{ fontSize: "0.85em", opacity: 0.7 }}>
              <em>Technical details: {details}</em>
            </p>
          )}
        </div>
      );
      setfailure_dlg(true);
      toggle();
    };

    var newOrg: ICreateOrgProps | null = {
      orgId: 0,
      companyName: companyName,
      billingRef: values["billingref"] === "" ? null : values["billingref"],
      houseAccount: Number(houseAccount) === 0 ? false : true,
    };
    newOrg = await CreateOrganisation(newOrg).catch(err => {
      const hint = isDuplicateKeyError(err)
        ? `An organisation with a conflicting value already exists (possibly the company name "${companyName}"). Please use a different company name or billing reference.`
        : "The organisation could not be created.";
      fail("Create organisation", err, hint);
      return null;
    });
    if (newOrg == null) {
      return false;
    }
    orgCreated = true;
    completed.push(`organisation "${companyName}"`);
    setHouseAccount(houseAccountOptions[0].value);

    var newBot: ICreateUserProps | null = {
      firstName: "automation",
      lastName: "bot",
      isBot: true,
      isApi: false,
      userId: 0,
      orgId: newOrg.orgId,
      inboxId: 0,
      imageUrl: "images/bot.png",
      hasImage: true,
    };
    newBot = await CreateUser(newBot).catch(err => {
      fail(
        "Create automation bot user",
        err,
        "This is an internal step that should not normally fail."
      );
      return null;
    });
    if (newBot == null) {
      return false;
    }
    completed.push("automation bot user");

    for (let i = 0; i < 5; i++) {
      var openingHours: IAddOpeningHoursProps = {
        orgId: newOrg.orgId,
        dayOfWeek: i,
        open: "09:00:00+00",
        close: "17:00:00+00",
      };
      await AddOpeningHours(openingHours);
    }

    var newApiAccount: ICreateApiProps | null = {
      apiAccountId: 0,
      providerId: apidata.msgbox_APIProvider[0].APIProviderId,
      orgId: newOrg.orgId,
      name: values["inboxname"],
      apiKey: values["apikey"],
      appName: values["appname"],
      partnerId: values["partnerid"],
      partnerToken: values["partnertoken"],
      phoneNumber: phoneNumber,
    };
    newApiAccount = await CreateApiAccount(newApiAccount).catch(err => {
      const hint = isDuplicateKeyError(err)
        ? `The phone number ${phoneNumber} (or another API account identifier) is already in use by an existing inbox.`
        : "The API account could not be created. This may be due to invalid GupShup credentials (App Name, Partner ID, Partner Token, API Key).";
      fail("Create API account", err, hint);
      return null;
    });
    if (newApiAccount == null) {
      return false;
    }
    completed.push("API account");

    const mathcingPlan = plans.filter((plan: any) => {
      return plan.label.trim() === values["inboxplan"].trim();
    });
    const planId = mathcingPlan[0].value;
    var newInbox: ICreateInboxProps | null = {
      inboxId: 0,
      orgId: newOrg.orgId,
      apiAccountId: newApiAccount.apiAccountId,
      name: values["inboxname"],
      planId: planId,
      isPersonal: false,
    };
    newInbox = await CreateInbox(newInbox).catch(err => {
      const hint = isDuplicateKeyError(err)
        ? `An inbox with the name "${values["inboxname"]}" already exists.`
        : "The inbox could not be created.";
      fail("Create inbox", err, hint);
      return null;
    });
    if (newInbox == null) {
      return false;
    }
    completed.push(`inbox "${values["inboxname"]}"`);

    var inboxFolder: ICreateFolderProps | null = {
      folderId: 0,
      inboxId: newInbox.inboxId,
      name: "Inbox",
      order: 1,
      isInbox: true,
      isArchive: false,
      isSpam: false,
    };
    inboxFolder = await CreateFolder(inboxFolder).catch(err => {
      fail(
        "Create Inbox folder",
        err,
        "This is an internal step that should not normally fail."
      );
      return null;
    });
    if (inboxFolder == null) {
      return false;
    }

    var archiveFolder: ICreateFolderProps | null = {
      folderId: 0,
      inboxId: newInbox.inboxId,
      name: "Archive",
      order: 2,
      isInbox: false,
      isArchive: true,
      isSpam: false,
    };
    archiveFolder = await CreateFolder(archiveFolder).catch(err => {
      fail(
        "Create Archive folder",
        err,
        "This is an internal step that should not normally fail."
      );
      return null;
    });
    if (archiveFolder == null) {
      return false;
    }

    var spamFolder: ICreateFolderProps | null = {
      folderId: 0,
      inboxId: newInbox.inboxId,
      name: "Spam",
      order: 3,
      isInbox: false,
      isArchive: false,
      isSpam: true,
    };
    spamFolder = await CreateFolder(spamFolder).catch(err => {
      fail(
        "Create Spam folder",
        err,
        "This is an internal step that should not normally fail."
      );
      return null;
    });
    if (spamFolder == null) {
      return false;
    }
    completed.push("inbox folders");

    var defaultResponse: ICreateAutomationReponse = {
      orgId: newOrg.orgId,
      apiAccountId: newApiAccount.apiAccountId,
      keyword: "default response",
      reply:
        "Thank you for messaging " +
        values["inboxname"] +
        ". How can we help you today?",
      isDeletable: false,
    };
    const defaultReponse = await CreateAutomation(defaultResponse).catch(
      err => {
        fail(
          "Create default automation rule",
          err,
          "This is an internal step that should not normally fail."
        );
        return null;
      }
    );
    if (defaultReponse == null) {
      return false;
    }

    var defaultAwayResponse: ICreateAutomationReponse = {
      orgId: newOrg.orgId,
      apiAccountId: newApiAccount.apiAccountId,
      keyword: "default away response",
      reply:
        "Thank you for messaging " +
        values["inboxname"] +
        ". We're currently closed, so we'll be in touch as soon as we can.",
      isDeletable: false,
    };
    const defaultAwayReponse = await CreateAutomation(
      defaultAwayResponse
    ).catch(err => {
      fail(
        "Create default away automation rule",
        err,
        "This is an internal step that should not normally fail."
      );
      return null;
    });
    if (defaultAwayReponse == null) {
      return false;
    }
    completed.push("default automation rules");

    var newUser: ICreateUserProps | null = {
      firstName: "API",
      lastName: "User",
      isBot: false,
      isApi: true,
      userId: 0,
      orgId: newOrg.orgId,
      inboxId: newInbox.inboxId,
      email: email,
      hasImage: false,
    };
    newUser = await CreateUser(newUser).catch(err => {
      const hint = isDuplicateKeyError(err)
        ? `The email address ${email} is already associated with an existing user.`
        : "The admin user could not be created.";
      fail("Create admin user", err, hint);
      return null;
    });
    if (newUser == null) {
      return false;
    }
    completed.push(`admin user ${email}`);

    var addUserToInbox: IAddUserToInboxProps = {
      inboxId: newInbox.inboxId,
      orgId: newOrg.orgId,
      userId: newUser.userId,
    };
    const inboxSuccess: boolean = await AddUserToInbox(addUserToInbox).catch(
      err => {
        fail(
          "Assign admin user to inbox",
          err,
          "This is an internal step that should not normally fail."
        );
        return false;
      }
    );
    if (inboxSuccess == false) {
      return false;
    }

    var addUserToRole: IAddUserToRoleProps = {
      userId: newUser.userId,
      orgId: newOrg.orgId,
      roleId: orgAdminRoleDate.msgbox_Role[0].RoleId,
    };
    const roleSuccess: boolean = await AddUserToRole(addUserToRole).catch(
      err => {
        fail(
          "Assign admin user to OrgAdmin role",
          err,
          "This is an internal step that should not normally fail."
        );
        return false;
      }
    );
    if (roleSuccess == false) {
      return false;
    }

    setdynamic_description("Organisation created successfully");
    setsuccess_dlg(true);
    toggle();
  };

  const modalBodyStyle = {
    color: "#000",
  };

  return (
    <React.Fragment>
      {failure_dlg ? (
        <SweetAlert
          error
          title={Theme.name}
          onConfirm={() => {
            setfailure_dlg(false);
          }}
        >
          {dynamic_description}
        </SweetAlert>
      ) : null}
      {success_dlg ? (
        <SweetAlert
          success
          title={Theme.name}
          onConfirm={() => {
            setsuccess_dlg(false);
            props.onRefetch();
          }}
        >
          {dynamic_description}
        </SweetAlert>
      ) : null}
      <Modal isOpen={props.modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle} tag="h4">
          Add New Organisation
        </ModalHeader>
        <ModalBody className="modelStyle">

        {plans.length > 0 ?
          <AvForm
            onValidSubmit={(e: any, values: any) => {
              handleValidOrganisationSubmit(values);
            }}
          >
            <Row form className="d-flex flex-row mb-3">
              <Col>
                <div className="mb-3">
                  <AvField
                    className="avInput"
                    name="companyname"
                    label="Company Name"
                    type="text"
                    placeholder="Enter company name"
                    errorMessage="Invalid company name"
                    validate={{
                      required: { value: true },
                    }}
                    value={""}
                  />
                </div>
                <div className="mb-3">
                  <AvField
                    className="avInput"
                    name="email"
                    label="Email"
                    type="email"
                    placeholder="Enter email for reseller admin user"
                    errorMessage="Invalid email, or a user with this email already exists"
                    validate={{
                      email: true,
                      required: { value: true },
                      function: (value: any) => {
                        if (!value) return true;
                        console.log(existingEmails);
                        return !existingEmails.includes(
                          String(value).toLowerCase()
                        );
                      },
                    }}
                    value={""}
                  />
                </div>
                <div className="mb-3">
                  <AvField
                    className="avInput"
                    name="inboxname"
                    label="Inbox Name"
                    type="text"
                    placeholder="Enter inbox name"
                    errorMessage="Invalid inbox name"
                    validate={{
                      required: { value: true },
                    }}
                    value={""}
                  />
                </div>


                <div className="mb-3">
                  <AvField
                    className="avInput"
                    name="inboxplan"
                    label="Inbox Plan"
                    type="select"
                    options={plans} 
                    value=""                   
                    errorMessage="Select plan"
                    validate={{
                    required: { value: true },
                    }}
                  >
                    <option value="" disabled>Select</option>
                   {plans.map((plan: any, index: any)=>{
                    return <option key={index}>{plan.label}</option>
                   })} 
                  </AvField>
                </div>


                <div className="mb-3">
                  <AvField
                    className="avInput"
                    name="billingref"
                    label="Billing Ref"
                    type="text"
                    placeholder="Enter billing ref"
                    errorMessage=""
                    value={""}
                  />
                </div>


                <div className="mb-3">
                  <AvField
                    className="avInput"
                    name="houseaccount"
                    label="House Account"
                    type="select" 
                    value={houseAccount}                   
                    errorMessage="Select house account value"
                    onChange={(e: any)=>{
                      setHouseAccount(e.target.value)
                    }}
                  >
                   {houseAccountOptions.map((option: any, index: any)=>{
                    return <option key={index} value={option.value}>{option.label}</option>
                   })} 
                  </AvField>
                </div>






              </Col>
              <Col className="px-2">
                <div className="mb-3">
                  <AvField
                    className="avInput"
                    name="appname"
                    label="App Name"
                    type="text"
                    placeholder="Enter App name from GupShup"
                    errorMessage="Invalid App Name"
                    validate={{
                      required: { value: true },
                    }}
                    value={""}
                  />
                </div>
                <div className="mb-3">
                  <AvField
                    className="avInput"
                    name="partnerid"
                    label="Partner Id"
                    type="text"
                    placeholder="Enter App ID from GupShup"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Please enter partner id from Gupshup",
                      },
                      pattern: {
                        value:
                          "^[A-Za-z0-9]{8}-([A-Za-z0-9]{4}-){3}[A-Za-z0-9]{12}$",
                        errorMessage:
                          "Should be in the format of 97067c1d-29d2-4303-ad0b-a92b81619ae9",
                      },
                    }}
                    value={""}
                  />
                </div>
                <div className="mb-3">
                  <AvField
                    className="avInput"
                    name="partnertoken"
                    label="Partner Token"
                    type="text"
                    placeholder="Enter App ID Token from GupShup"
                    errorMessage="Invalid Partner Token"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Please enter partner token from Gupshup",
                      },
                      minLength: {
                        value: 35,
                        errorMessage:
                          "Partner Token must be 35 characters long",
                      },
                      maxLength: {
                        value: 35,
                        errorMessage:
                          "Partner Token must be 35 characters long",
                      },
                      pattern: {
                        value: "^sk_[a-z0-9]{32}$",
                        errorMessage:
                          "Should be in the format of sk_b3hd8f60eaf456db2a7e925b73a81f53",
                      },
                    }}
                    value={""}
                  />
                </div>


                <div className="mb-3">
                  <AvField
                    className="avInput"
                    name="apikey"
                    label="API Key"
                    placeholder="Enter App API Key from GupShup"
                    type="text"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Please enter API Key",
                      },
                      minLength: {
                        value: 32,
                        errorMessage: "API Key must be 32 characters long",
                      },
                      maxLength: {
                        value: 32,
                        errorMessage: "API Key must be 32 characters long",
                      },
                    }}
                    value={""}
                  />
                </div>

                <div className="mb-3">
                  <AvField
                    className="avInput"
                    name="phonenumber"
                    label="Phone Number"
                    type="text"
                    placeholder="Enter Phone Number (ISO Format eg +44777777777)"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Please enter phone number",
                      },
                      pattern: {
                        value: "^\\+[0-9]{11,14}$",
                        errorMessage:
                          "Phone Number must be in the format +44777777777",
                      },
                      function: (value: any) => {
                        if (!value) return true;
                        if (existingPhoneNumbers.includes(value)) {
                          return "This phone number is already in use by an existing API account";
                        }
                        return true;
                      },
                    }}
                    value={""}
                  />
                </div>


              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end">
                  <button
                    type="button"
                    className="btn btn-light w-sm"
                    onClick={handleShow}
                  >
                    Close
                  </button>
                  <button type="submit" className="btn  btn-success save-user">
                    Save
                  </button>
                </div>
              </Col>
            </Row>
          </AvForm>
          : <p>Loading...</p>}

        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default AddOrganisation;
